import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import CgPopover from 'modules/Common/ui/CgPopover';
import { highestSeverity } from 'modules/FreeSupplier/app/state/gaps';
import { SeverityChip } from './GapList';

const TONE = {
  high: 'text-red-600 bg-red-50 border-red-200',
  medium: 'text-amber-700 bg-amber-50 border-amber-200',
  low: 'text-blue-700 bg-blue-50 border-blue-200',
};

// Compact gap-count chip for installation cards — hover lists the gaps.
// Mirrors the four visual states of SupplierDataGapsCell (complete vs gaps
// with a count + popover breakdown).
export default function GapBadge({ gaps }) {
  if (!gaps || gaps.length === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-1.5 py-0.5">
        <FontAwesomeIcon
          icon={faCircleCheck}
          className="text-[9px]"
        />
        Complete
      </span>
    );
  }

  const tone = TONE[highestSeverity(gaps)];

  return (
    <CgPopover
      trigger="hover"
      position="top"
      maxWidth="max-w-[340px]"
      triggerElement={
        <span
          className={`inline-flex items-center gap-1 text-[10px] font-semibold rounded-full border px-1.5 py-0.5 cursor-help ${tone}`}
        >
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="text-[9px]"
          />
          {gaps.length} gap{gaps.length === 1 ? '' : 's'}
        </span>
      }
      popoverContent={
        <ul className="list-none m-0 p-1 flex flex-col gap-1.5 min-w-[240px]">
          {gaps.map((gap) => (
            <li
              key={gap.id}
              className="flex items-start gap-2"
            >
              <SeverityChip severity={gap.severity} />
              <span className="text-xs text-slate-600">{gap.message}</span>
            </li>
          ))}
        </ul>
      }
    />
  );
}
